class ResponsiveUIChanges {
    constructor() {

    }

    init(helpers, collapsibleSection) {
        const self = this;
        self.helpers = helpers;
        self.collapsibleSection = collapsibleSection;

        const root = document.querySelector('html');

        const rootResizeObserver = new ResizeObserver( (entries) => {
            let entry = entries[0];

            if (root !== entry.target) return;

            let computedStyle = getComputedStyle(entry.target);

            let responsiveUIBreakpoint = computedStyle.getPropertyValue('--responsive-ui-breakpoint-px') ? computedStyle.getPropertyValue('--responsive-ui-breakpoint-px') : null;

            let viewportWidth = entry.borderBoxSize[0].inlineSize ? entry.borderBoxSize[0].inlineSize : null;

            if (!responsiveUIBreakpoint) return;
            if (!viewportWidth) return;

            const mobileNavigation = entry.target.querySelector('.site-navigation-language-and-search'),
                desktopNavigation = entry.target.querySelector('.site-navigation-language-and-search--desktop'),
                sitewideBanner = entry.target.querySelector('.sitewide-banner');

                let onThisPageNavigation = document.querySelector('.on-this-page-navigation');

            let headerHeight = 0,
                sitewideBannerHeight;

            if (viewportWidth >= responsiveUIBreakpoint) {
                self.helpers.accessibleHide(mobileNavigation);
                self.helpers.accessibleShow(desktopNavigation);

                headerHeight += desktopNavigation.offsetHeight;
            } else {
                self.helpers.accessibleHide(desktopNavigation);
                self.helpers.accessibleShow(mobileNavigation);

                headerHeight += mobileNavigation.offsetHeight;
            }

            sitewideBannerHeight = 0;
            if (sitewideBanner) {
                sitewideBannerHeight = sitewideBanner.offsetHeight;
            }

            if (onThisPageNavigation) {
                if (viewportWidth >= 840) {
                    self.removeCollapsibleSectionUI(onThisPageNavigation, self);
                } else {
                    self.addCollapsibleSectionUI(onThisPageNavigation, self);

                    headerHeight += onThisPageNavigation.offsetHeight;
                }
            }

            root.style.setProperty('--header-height', headerHeight / 10 + 'rem');
            root.dataset.headerHeight = headerHeight;

            root.style.setProperty('--sitewide-banner-height', sitewideBannerHeight / 10 + 'rem');
        });

        rootResizeObserver.observe(root);
        window.scrollBy(0,1);
        window.scrollBy(0,-1);

        document.body.classList.add('not-scrolled');

        window.addEventListener('scroll', () => {
            document.body.classList.remove('not-scrolled');
        }, { once: true });

        // self.updateBodyClassOnScroll();
    }

    addCollapsibleSectionUI(element, self) {
        if (element.classList.contains('js-collapsible-section') && element.classList.contains('collapse-on-anchor-click')) return;

        element.classList.add('js-collapsible-section');
        element.classList.add('collapse-on-anchor-click');

        element.addEventListener('click', function (e) {

            if (!element.classList.contains('collapse-on-anchor-click')) return;

            if (e.target.tagName === 'A') {
                // Return early if the `e.target` link not an on-page link. We want clicks on these links to behave as expected
                if (e.target.getAttribute('href')[0] !== '#') return;

                // (For on-page links) Intercept the `click` and prevent the default "user just clicked a link" behaviour
                e.stopImmediatePropagation();
                // e.preventDefault();

                let target = document.querySelector(e.target.getAttribute('href'));

                // Collapse the element and notify assistive technology users that this has occurred
                element.querySelector('button').click();
                wp.a11y.speak('On This Page navigation has been automatically collapsed.');

                // Allow the `<a>`'s target element to be focused
                target.setAttribute('tabindex', '-1');

                // Focus the `<a>`'s target element
                target.focus();

                // Remove the `tabindex` attribute the restore the target element to its default state (no `tabindex`)
                target.removeAttribute('tabindex');
            }
        });

        self.collapsibleSection.enhance(element, self.collapsibleSection);
    }

    removeCollapsibleSectionUI(element, self) {
        if (!element) return;

        self.collapsibleSection.unenhance(element, self.collapsibleSection);
        element.classList.remove('collapse-on-anchor-click');
    }

    // updateBodyClassOnScroll() {
    //     let observer = new IntersectionObserver(
    //         entries => {
    //             entries.forEach((entry) => {
    //                 if (!entry.isIntersecting) {
    //                     document.body.classList.remove('not-scrolled');
    //                     document.body.style.background = 'red';
    //                 } else {
    //                     document.body.classList.add('not-scrolled');
    //                 }
    //             });
    //         },
    //       {
    //         treshold: 0,
    //       }
    //     );

    //     observer.observe(document.querySelector('body > header + *'));
    // }
}// end Class

// Singleton
export default ResponsiveUIChanges;
